import { useEffect, useState } from "react";
import {
    Button,
    IconButton,
    Grid,
    Typography,
    TableContainer,
    Tooltip,
    DialogTitle,
    Dialog,
    DialogContent,
    CircularProgressProps,
    CircularProgress,
    Box,
    DialogActions
} from "@mui/material";
import useStyles from "../../../css/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { HeaderLogo } from "../../../store";
import { useMediaQuery } from "@mui/material";
import Header from "../../../components/Header";
import { UpdateLogo } from "../../../api";


function CircularProgressWithLabel(
    props: CircularProgressProps & { value: number },
) {
    return (
        <Box style={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" style={{ color: "#18a2b8" }} {...props} />
            <Box
                style={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
            </Box>
        </Box>
    );
}

function Upload(props: any) {
    const matches = useMediaQuery("(min-width:600px)");
    const [selectedImage, setSelectedImage] = useState<HeaderLogo>({} as HeaderLogo);
    const [disableButtons, setDisableButtons] = useState<boolean>(true);
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [showPreview, setShowPreview] = useState<boolean>(false);
    const [progress, setProgress] = useState(10);
    const styles = useStyles();
    var JSAlert = require("js-alert");
    const addImage = (e: any) => {
        const file = e.target.files[0];
        const fileSize = Number((file.size / (1024 * 1024)).toFixed(3));
        if ((file.type === "image/png" || file.type === "image/jpeg") && fileSize > 0) {
            if (fileSize <= 6) {
                const reader = new FileReader();
                reader.onload = () => {
                    const input = {
                        FileName: file.name,
                        FileType: file.type,
                        FileSize: fileSize,
                        //Base64EncodedFile: reader.result?.toString().split("base64,")[1],
                        Base64EncodedFile: reader.result
                    } as HeaderLogo;
                    setSelectedImage(input);
                };
                reader.readAsDataURL(file);
            }
            else {
                JSAlert.alert("Please select a file smaller than 6MB", null, JSAlert.Icons.Warning);
            }
        }
        else {
            JSAlert.alert("Invalid file type. Please select a valid file", null, JSAlert.Icons.Warning);
        }
    };
    const handleRemoveClick = () => {
        var alert = new JSAlert("Are you sure you want to delete this file?", "", JSAlert.Icons.Question);
        alert.addButton("Yes").then(function () {
            setSelectedImage({} as HeaderLogo);
        });
        alert.addButton("No").then(function () {
            return;
        });
        alert.show();
    };
    const submitDocuments = async () => {
        setDisableButtons(true);
        setOpenDialog(true);
        const result = await UpdateLogo(selectedImage);
        if (result === 200) {
            setOpenDialog(false);
            JSAlert.alert("File(s) uploaded successfully!", null, JSAlert.Icons.Success).then(function () {
                setSelectedImage({} as HeaderLogo);
                window.location.reload();
            });
        }
        else {
            setOpenDialog(false);
        }
    }

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
        }, 800);
        return () => {
            clearInterval(timer);
        };
    }, []);


    return (
        <Box
            sx={
                matches == false
                    ? {
                        width: "100%",
                        padding: "16px",
                        minHeight: "70vh",
                    }
                    : {
                        width: "100%",
                        padding: "24px 80px 24px 80px",
                        minHeight: "70vh",
                    }
            }
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        Please upload the image to change the header logo.
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={4} md={4} lg={4}>
                    <Button
                        variant="contained"
                        component="label"
                        className={styles.navigationButton}
                    >
                        Choose File
                        <input
                            type="file"
                            name="document_path"
                            onChange={e => addImage(e)}
                            onClick={(event) => {
                                event.currentTarget.value = ''
                            }}
                            accept="image/*"
                            hidden
                        />
                    </Button>
                    <Typography variant="subtitle2">
                        (Accepted file types: jpg, png)
                    </Typography>
                </Grid>
                <Grid item xs={6} sm={4} md={4} lg={4}>
                    <Button
                        onClick={() => setShowPreview(true)}
                        variant="contained"
                        id="preview"
                        className={styles.navigationButton}
                        style={{ display: selectedImage.FileName ? "block" : "none" }}
                    >
                        Preview
                    </Button>
                </Grid>
                <Grid item xs={6} sm={4} md={4} lg={4}>
                    <Button
                        onClick={submitDocuments}
                        variant="contained"
                        id="upload"
                        className={styles.navigationButton}
                        style={{ display: selectedImage.FileName ? "block" : "none" }}
                    >
                        Upload
                    </Button>
                </Grid>
                <Grid item xs={12} style={{ display: selectedImage.FileName ? "block" : "none" }}>
                    <TableContainer>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontSize: "1rem" }}><b>Name</b></TableCell>
                                    <TableCell style={{ fontSize: "1rem" }}><b>Size</b></TableCell>
                                    <TableCell style={{ fontSize: "1rem" }}><b>Tools</b></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        {selectedImage.FileName}
                                    </TableCell>
                                    <TableCell>
                                        {selectedImage.FileSize + " MB"}
                                    </TableCell>
                                    <TableCell>
                                        <Tooltip title="Delete">
                                            <IconButton aria-label="delete" onClick={() => handleRemoveClick()} size="small">
                                                <DeleteIcon fontSize="small" color="error" />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid item xs={12} style={{ display: showPreview && selectedImage.FileName ? "block" : "none" }}>
                    <Typography variant="h6">
                        <b>Preview</b>
                    </Typography>
                </Grid>
                <Grid item xs={12} style={{ display: showPreview && selectedImage.FileName ? "block" : "none", pointerEvents: "none" }}>
                    {/* <Header src={"data:" + selectedImage.FileType + ";base64, " + selectedImage.Base64EncodedFile} /> */}
                    <Header src={selectedImage.Base64EncodedFile} />
                </Grid>
            </Grid>
            <Dialog open={openDialog} fullWidth maxWidth={"xs"}>
                <DialogTitle style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                    <Typography style={{ color: "#18a2b8" }}>Uploading...</Typography>
                </DialogTitle>
                <DialogContent style={{ display: "flex", alignContent: "center", justifyContent: "center" }}>
                    <CircularProgressWithLabel value={progress} />
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </Box>
    );
}

export default Upload;